export default {
  path: '/lvy-application-permission',
  component: () => import('./LVYApplicationPermission'),
  meta: {
    title: '青藤之恋应用权限',
    designWidth:750,
    expireIn: '',
  }
}
